module.exports = __webpack_public_path__ + "static/media/info.3cdafa91.svg";